import { createApp } from "vue"
import Vue3Toastify from "vue3-toastify"
import "vue3-toastify/dist/index.css"

import App from "./App.vue"
import router from "./router"

import resourcesPlugin from "frappe-ui-src/resources/plugin"
import { setConfig } from "frappe-ui-src/utils/config"
import { backendRequest } from "./data/backend"

import "./index.css"
import "./styles/toasts.css"

const app = createApp(App)

setConfig("resourceFetcher", backendRequest)

app.use(router)
app.use(resourcesPlugin)
app.use(Vue3Toastify, {
  position: "bottom-right",
  autoClose: 5000,
  limit: 3,
  pauseOnHover: true,
  pauseOnFocusLoss: true,
  closeOnClick: false,
  theme: "light",
})

app.mount("#app")
